import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { IconContext } from "react-icons";
import * as ReactIcons from "react-icons/fa";

interface NavBarProps {
  items: {
    route: string;
    label: string;
    icon: string;
  }[];
}

const NavBar: React.FC<NavBarProps> = ({ items }) => {
  return (
    <NavBarWrapper>
      <NavList>
        {items.map((item, index) => {
          const IconComponent = ReactIcons[item.icon as keyof typeof ReactIcons];
          return (
            <NavItem key={index}>
              <NavLink to={item.route}>
                <IconContext.Provider value={{ className: "icon" }}>
                  <IconComponent />
                </IconContext.Provider>
                <div>{item.label}</div>
              </NavLink>
            </NavItem>
          );
        })}
      </NavList>
    </NavBarWrapper>
  );
};

const NavBarWrapper = styled.nav`
  position: fixed;
  bottom: 0;
  width: calc(100vw - 20px);
  background-color: ${({ theme }) => theme.navBgColor};
  color: #fff;
  box-shadow: 0px 0 10px rgba(0, 0, 0, 0.3);
  padding: 10px 0;
  transition: all 0.25s ease;
  border-radius: 15px;
  margin: 0 0 25px 0;
`;

const NavList = styled.ul`
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  list-style: none;
  margin: 0;
`;

const NavItem = styled.li`
  text-align: center;
`;

const NavLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: ${({ theme }) => theme.navTextColor};
  height: 40px;
  font-size: 16px;
`;

export default NavBar;
